const Form063TC = {
    stepName: {
        importantNotes: "重要事項",
        schoolOfInformation: "基本資料",
        changesInSalaryDetails: "署任安排詳情",
        salaryParticulars: "認證",
        noteInformation: "備註資料",
        attachment: "附件",
        confirmation: "確認",
    },
    label: {
        header: {
            headerOne: "重要事項",
        },
        statement: "本人已閱讀、明白及同意上述條款及細則",
        pointOption: {
            fortyNine: "49",
            fortyEight: "48",
            fortySeven: "47",
            fortySix: "46（44B）",
            fortyFive: "45（44A）",
            fortyFour: "44",
            fortyThree: "43",
            fortyTwo: "42",
            fortyOne: "41",
            forty: "40",
            thirtyNine: "39",
            thirtyEight: "38",
            thirtySeven: "37",
            thirtySix: "36（33C）",
            thirtyFive: "35（33B）",
            thirtyFour: "34（33A）",
            thirtyThree: "33",
            thirtyTwo: "32",
            thirtyOne: "31",
            thirty: "30",
            twentyNine: "29",
            twentyEight: "28",
            twentySeven: "27",
            twentySix: "26",
            twentyFive: "25",
            twentyFour: "24",
            twentyThree: "23",
            twentyTwo: "22",
            twentyOne: "21",
            twenty: "20",
            nineteen: "19",
            eighteen: "18",
            seventeen: "17",
            sixteen: "16",
            fifteen: "15",
            fourteen: "14",
            thirteen: "13",
            twelve: "12",
            eleven: "11",
            ten: "10",
            nine: "9",
            eight: "8",
            seven: "7",
            six: "6",
            five: "5",
            four: "4",
            three: "3",
            two: "2",
            one: "1",
            zero: "0",
        },
        schoolSessionOption: {
            am: "上午",
            pm: "下午",
            wholeDay: "全日",
        },
        committeeOption: {
            smc: "校董會",
            imc: "法團校董會",
        },
        chooseTheSchoolOption: {
            primarySchool: "小學",
            secondarySchool: "中學",
            specialSchool: "特殊學校",
        },
        schoolOfInformation: "基本資料",

        schoolName: "學校名稱",
        schoolCode: " 學校代碼",
        schoolSession: "授課時間",
        contactPerson: "聯絡人",
        tel: "電話號碼",
        contactAndTelText1: "學校聯絡人",
        contactAndTelText2: "及其電話號碼",
        contactAndTelText3: "(以便教育局處理本表格時作查詢之用)",
        committee: "校董會",
        mode: "已批准下列署任安排",
        ref: "檔號",
        date: "日期",
        committeeText1: "",
        committeeText2: "已批准下列署任安排﹝檔號：",
        committeeText3: "及日期：",
        committeeText4: "﹞",
        committeeText5: "，而有關人員的薪金資料需因此而作出以下的改動：",
        // two page
        changesInSalaryDetails: "署任安排詳情",
        englishName: "教師英文姓名",
        chineseName: "教師中文姓名",
        hkid: "香港身份證號碼",
        srn: "員工檔號",
        substantiveRank: "實任職級",
        actingPeriod: "署任期",
        actingPeriodFrom: "署任期由",
        actingPeriodTo: "署任期至",
        rankOfActingAppointment: "署任職級",
        conditionsCheck: "",
        schoolHead: "校長",
        schoolHeadTrue: "是",
        schoolHeadFalse: "否",
        actingAllowance: "署任津貼",
        difference: "實職薪金與總薪級表差額",
        point: "總薪級表",
        actingText1: "實職薪金與總薪級表第",
        actingText2: "點差額的",
        actingText3: "%",
        approvalForDetails:
            "有關校長職位的署任，請提供已獲教育局事先批准的詳情 ",
        fileRefNo: "檔號",
        fileDate: "文檔日期",
        attachmentForSchool: "批准信",
        // three page

        // four page
        personalStatement: "陳訴",
        title: "個人資料收集聲明",
        //    five page
        attachment: "教職員編制及在職人數表",
        chooseTheSchool: "選擇學校（小學／中學／特殊學校）",
        attachmentLink: "點擊此處下載附件表格",
        termsConditions: "本人已參閱、明白並同意上述條款及細則。",
        confirm: "確認",
        collectionStatement: "個人資料收集聲明",
        ssdo: "學校所屬的教育局區域教育服務處﹝經辦人：高級學校發展主任",
        ssdo2: " ﹞",
        ssdoLabel: "高級學校發展主任",
        declaration: "本人已閱讀「個人資料收集聲明」及完全明白其內容。",
        approverOnly: "本人明白需透過「智方便+」帳戶以辧理申請。",
        original: "正本：",
        duplicate: "副本：",
        triplicate: "第二副本：",
        originalText: "教育局公積金組",
        triplicateText: "學校存檔",
    },
    note: {
        note1: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途︰",
        note2: "每份表格只適用於一項署任安排。",
        note3: "請在填寫前，詳細閱讀個人資料收集聲明。",
        note4: "請確保教師知悉所填報的內容，並已閱讀個人資料收集聲明。",
        note5: "1.在晉升或署任安排的生效日期前須完成所需的程序（包括校董會／法團校董會的批准）。在一般情況下，晉升或署任安排的生效日期不具追溯效力。",
        note6: "2.資助中學、特殊中學或設有中小學部的特殊學校中學部的全職常額首席學位教師／高級學位教師／學位教師倘獲推薦及批准署任較高職級的一級校長／二級校長／首席學位教師／高級學位教師職位並擔任專責職務，而其合資格署任期達30個曆日或以上，可獲發放署任津貼。",
        note7: "3.如署任人員連續休假超過3個工作天影響其合資格署任期的計算及／或涉及署任津貼的扣減（包括休假日及當中的公眾假期和星期日），學校須填寫署任安排﹝署任教師休假／缺勤超逾連續3天以上須調整署任津貼的通知﹞表格通知本局調整署任津貼。",
        note8: "4.詳情請參閱教育局通告第8／2004號的附錄。如有關署任津貼率有更改，請填寫署任安排﹝署任津貼率由90%調整至100%的通知﹞表格。",
        note9: "5.在2019／20學年起，在教師職位學位化政策全面推行的情況下，資助學校核准編制內的所有教席均為學位教師職位。在2019／20學年起，非學位職系教師的晉升機制將不獲保留。換句話說，非學位教師職系不應該有任何新的晉升及署任（有待實任）安排。",
        note10: "6.教育局將會對每份署任申請作出編制預先核查。如有關署任教師於委任日已超逾該校的核准教學人員編制，在釐清該署任安排是否符合編制人數之前，該薪金津貼將不會發放給學校。",
        //
        note11: "1.在第6步 – 附件(如有)內的教職員編制及在職人數表顯示有空缺作出上述署任安排。",
        note12: "2.有關校長職位的署任，請提供已獲教育局事先批准的詳情（檔號及日期：",
        note12Last: "）。",
        note13: "3.上述教師獲確認實際晉升",
        note13b: "時，本人會通知教育局，並呈交《教職員晉升事宜》表格。",
        note14: "4.本人承諾，若上述教師的署任期未能符合教育局通告第8／2004號第2段有關發放署任津貼的合資格署任期的各項規定",
        note14b:
            "，本人會立即通知教育局公積金組，並將通知副本送交有關的學校發展主任。",
        note15: "5.本人現確認在本表格的基本資料，署任安排詳情及上文第1至2段內所載的資料均正確無誤。本人承諾有關署任事宜不會令擔任晉升職級的教學／非教學人員的人數超逾已核准的編制。本人並承諾本校會把多付的薪金津貼退還教育局。",
        //
        note16: "辦理與聘用有關的事宜；",
        note17: "處理發放薪金津貼及其他政府資助；",
        note18: "計算公積金的供款；",
        note19: "進行核數工作；",
        note20: "進行研究及統計資料，以便規劃教育服務；",
        note21: "處理有關教育專業人員發展的事宜；",
        note22: "執行相關《資助則例》、《教育條例》、《教育規例》及《補助/津貼學校公積金規則》的規定。",
        note23: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
        note24: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
        note25: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        note26: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向有關高級學校發展主任提出。",
        // five page
    },
    noteList: {
        noteOne:
            "在晉升或署任安排的生效日期前須完成所需的程序（包括校董會／法團校董會的批准）。在一般情況下，晉升或署任安排的生效日期不具追溯效力。",
        noteTwo:
            "資助中學、特殊中學或設有中小學部的特殊學校中學部的全職常額首席學位教師／高級學位教師／學位教師倘獲推薦及批准署任較高職級的一級校長／二級校長／首席學位教師／高級學位教師職位並擔任專責職務，而其合資格署任期達30個曆日或以上，可獲發放署任津貼。",
        noteThree:
            "如署任人員連續休假超過3個工作天影響其合資格署任期的計算及／或涉及署任津貼的扣減（包括休假日及當中的公眾假期和星期日），學校須填寫署任安排﹝署任教師休假／缺勤超逾連續3天以上須調整署任津貼的通知﹞表格通知本局調整署任津貼。",
        noteFour:
            "詳情請參閱教育局通告第8／2004號的附錄。如有關署任津貼率有更改，請填寫署任安排﹝署任津貼率由90%調整至100%的通知﹞表格。",
        noteFive:
            "校長職位的署任必須事先獲教育局批准。如有查詢，請聯絡有關學校發展主任。",
    },
    errorMsg: {
        E0001: "請輸入一個有效的學校名稱",
        E0002: "請輸入一個有效的學校代碼（4位字符）",
        E0003: "請輸入正確的規則（包含數字字符和五個特殊字符，它們是空格（ ）、加號（+）、井號（#）、方括號（（））和連字符（-））",
        E0004: "請輸入正確的規則（包含英文數字字符和八個特殊字符，分別是撇號（'）、空格（ ）、點（.）、與號（&）、逗號（,）、方括號（（））、斜線（／）和連字符（-））",
        E0005: "請輸入正確的規則（包含數字字符）",
        E0006: "請輸入一個有效的檔號",
        E0007: "請輸入一個有效的聯絡人",
        E0008: "請輸入正確的規則（包含漢字字符和五個特殊字符，它們是空格（ ）、點（.）、逗號（,）、撇號（'）和連字符（-）。數字是不允許的。）",
        englishName: "請輸入一個有效的教師英文姓名",
        chineseName: "請輸入一個有效的教師中文姓名",
        srnRule: "請輸入一個有效的8位字符檔號",
        countryCode: "請輸入一個有效的國家代碼",
        substantiveRank: "請輸入一個有效的實任職級",
        rankOfActingAppointment: "請輸入一個有效的署任職級",
        refNum: "請輸入一個有效檔號",
        hkidEmpty: "括號內的值不能為空",
        Note001:
            "注 1.所有晉升教師或代理任命的必要程式都應在生效日期之前完成，包括獲得校董會/校董會的批准。 一般情況下，晉升日期和代理任命日期不具有追溯效力。",
    },
};
export default Form063TC;
